import styled from 'styled-components';
export const LoadingSpinnerSVG = styled.svg `
  margin: auto;
  background: transparent;
  display: block;
`;
//# sourceMappingURL=BKJLoadingSpinner.styled.js.map